import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  paymentData: {},
  paymentTypeInput: {
    paymentType: null
  },
  bankAccountOwner: null
}

const OrderPaymentModule = {
  namespaced: true,
  state: initialState,
  getters: {
    getPayment: state => {
      if (state.paymentTypeInput.paymentType === null || state.paymentTypeInput.paymentType === '' || state.paymentTypeInput.paymentType === 'withoutPayment') {
        return null
      }
      if (state.paymentTypeInput.paymentType === 'creditCard') {
        return {
          company: state.paymentTypeInput.company,
          expiryMonth: state.paymentTypeInput.expiryMonth,
          expiryYear: state.paymentTypeInput.expiryYear,
          holder: state.paymentTypeInput.holder,
          lastDigits: state.paymentTypeInput.lastDigits,
          paymentType: state.paymentTypeInput.paymentType,
          registrationId: state.paymentTypeInput.registrationId
        }
      } else if (state.paymentTypeInput.paymentType === 'bankAccount') {
        return {
          paymentType: state.paymentTypeInput.paymentType,
          owner: state.bankAccountOwner,
          iban: state.paymentTypeInput.iban
        }
      } else if (state.paymentTypeInput.paymentType === 'paypal') {
        return {
          paymentType: state.paymentTypeInput.paymentType
        }
      }

      return state.paymentTypeInput
    },
    paymentContext: (state, getters, rootState, rootGetters) => {
      return {
        firstName: rootGetters['orderProduct/personalData/firstName'],
        lastName: rootGetters['orderProduct/personalData/lastName'],
        email: rootGetters['orderProduct/personalData/email'],
        address: rootGetters['orderProduct/personalData/address']
      }
    },
    payment: state => state.paymentData
  },
  mutations: {
    storePaymentData (state, paymentData) {
      state.paymentData = paymentData
      state.paymentTypeInput = Object.assign(state.paymentTypeInput, paymentData)
    },
    storeBankAccountOwner (state, paymentContext) {
      state.bankAccountOwner = paymentContext.firstName + ' ' + paymentContext.lastName
    }
  },
  actions: {
    async validateAndSavePayment ({ commit, dispatch, state, getters, rootGetters }, { paymentData }) {
      commit('clearMessages', {}, { root: true })
      if (['withoutPayment', 'paypal'].includes(paymentData.paymentType)) {
        commit('storePaymentData', paymentData)
        return true
      }
      const apolloClient = getProvider().defaultClient
      delete paymentData.paymentConfirmation
      delete paymentData.__typename
      delete paymentData.bin
      return apolloClient.mutate({
        mutation: gql`mutation order ($validatePaymentInput: ValidatePaymentInput!) {
          validatePayment (validatePayment: $validatePaymentInput){
            success
          }
        }`,
        variables: {
          validatePaymentInput: {
            ...rootGetters['orderProduct/personalData/validateAddressCore'],
            address: rootGetters['orderProduct/personalData/address'],
            paymentType: paymentData
          }
        }
      }).then((response) => {
        if (response.data.validatePayment.success) {
          commit('storePaymentData', paymentData)
          commit('storeBankAccountOwner', getters.paymentContext)
          return true
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }

  }
}

export default OrderPaymentModule
